<template>
  <div>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        class="mt-3"
        pagination
        :data="tickets"
        description
        search
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
        @selected="handleSelected"
      >
        <template slot="header">
          <!-- ADD NEW -->
        </template>
        <template slot="thead">
          <vs-th>{{ $t("entity.label.ticket_number") }}</vs-th>
          <vs-th>{{ $t("entity.label.priority") }}</vs-th>
          <vs-th>{{ $t("entity.label.ticket_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.problem_code") }}</vs-th>
          <vs-th>{{ $t("entity.label.status") }}</vs-th>
          <vs-th>{{ $t("entity.label.title") }}</vs-th>
          <vs-th>{{ $t("entity.label.assign_to") }}</vs-th>
          <vs-th class="tHeadCenter">{{ $t("entity.label.actions") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" :data="ticket" v-for="(ticket, index) in data">
            <vs-td :data="ticket.ticketNumber">{{ ticket.ticketNumber }}</vs-td>
            <vs-td :data="ticket.priority">{{ ticket.priority }}</vs-td>
            <vs-td :data="getDate(ticket.ticketDate)">{{
              getDate(ticket.ticketDate)
            }}</vs-td>
            <vs-td :data="ticket.problemDescription">{{
              ticket.problemDescription
            }}</vs-td>
            <vs-td :data="ticket.status">
              <vs-chip
                :color="statusColor(ticket.status)"
                class="priority-status"
                >{{ ticket.status }}
              </vs-chip></vs-td
            >
            <vs-td :data="ticket.title">{{ ticket.title }}</vs-td>
            <vs-td :data="ticket.userName">{{ ticket.userName }}</vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <feather-icon
                  v-if="ticket.DocumentId"
                  :title="$t('entity.label.DownloadUploadedFile')"
                  icon="DownloadIcon"
                  class="text-warning icon_row"
                  @click.stop="download(ticket.DocumentId, ticket.fileName)"
                  svgClasses="w-5 h-5 stroke-current"
                />
                <feather-icon
                  v-if="ticket.status !== 'CLOSED'"
                  @click.stop="editTicket(ticket)"
                  class="icon_row"
                  :title="$t('entity.label.Edit')"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 stroke-current orange_icon"
                />
                <feather-icon
                  v-if="ticket.status !== 'CLOSED'"
                  @click.stop="removeTicket(ticket.id)"
                  class="icon_row"
                  :title="$t('entity.label.Close')"
                  icon="XIcon"
                  svgClasses="w-5 h-5 stroke-current"
                />
                <feather-icon
                  v-if="ticket.status === 'CLOSED'"
                  :title="$t('entity.label.ReopenTicket')"
                  @click.stop="reopenTicket(ticket.id)"
                  icon="RefreshCwIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.close_ticket')"
        :active.sync="cancelTicketPopup"
        class="popup-close mid-popup"
      >
        <form ref="form">
          <div class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("entity.label.status")
                }}<span class="required"> *</span></small
              >
              <v-select
                label="mCodeValue"
                :options="cancelStatus"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="cancelObj.status"
                :reduce="(userName) => userName.id"
                class="min-w-200 w-full mb-2"
              />
            </div>
          </div>
          <div class="vx-col sm:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("entity.label.ResolutionDescription")
                }}<span class="required"> *</span></small
              >
              <vs-textarea
                class="w-full textbox"
                v-model="cancelObj.resolutionDescription"
                hint="Please provide as much detail as possible so we can best assist you."
              />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="cancelTicket"
                class="footerButton-next mt-4 mb-4"
                style="top: 0px"
                >{{ $t("entity.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.ReopenTicket')"
        :active.sync="reopenTicketPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="vx-col sm:w-full lg:w-full md:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.comment")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.comment')"
                >
                  <vs-textarea class="w-full" v-model="reopenComment" />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="reopenCustomerTicket"
                  class="footerButton-next mt-4 mb-4"
                  style="top: 0px"
                  >{{ $t("customers.label.reopen") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <EditTicket
      :active="ticketPopupEdit"
      @closePopup="ticketPopupEdit = false"
      :entityId="entityId"
      :id="id"
    />
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import { setHeader, removeHeader } from "@/http";
import vSelect from "vue-select";
import EditTicket from "./EditTicket.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: ["entityId"],
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",

      ticketPopupEdit: false,
      cancelTicketPopup: false,
      descriptionItems: [5, 10, 15],
      agreementDetails: [],
      bulkUploads: {
        file: null,
      },
      cancelStatus: [],
      id: 0,
      cancelObj: {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      },
      ticketId: null,
      reopenTicketPopup: false,
      reopenComment: "",
    };
  },
  components: {
    "v-select": vSelect,
    EditTicket,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "OPEN":
          color = "primary";
          break;
        case "CLOSED":
          color = "danger";
          break;
        case "WORKING":
          color = "warning";
          break;
        case "REOPEN":
          color = "orange";
          break;
        default:
          color = "black";
      }
      return color;
    },
    async reopenTicket(id) {
      this.reopenTicketPopup = true;
      this.ticketId = id;
    },
    async reopenCustomerTicket() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch(
          "customerTicket/reopenOfficeEntityTicketAction",
          {
            id: this.ticketId,
            data: { comments: this.reopenComment },
          }
        );
        this.getTickets();
        this.reopenTicketPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Reopened Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTickets() {
      try {
        this.$store.dispatch("entity/setEntityTickets", this.entityId);
      } catch (e) {
        console.log("Something went wrong while retrieving entity Tickets", e);
      }
    },
    handleSelected(item) {
      this.$router.push({
        name: "View Ticket",
        params: { entityId: this.entityId, id: item.id },
      });
    },
    editTicket(ticket) {
      this.id = ticket.id;
      this.ticketPopupEdit = true;
      this.ticketTemplate();
    },

    download(id, file) {
      this.$store
        .dispatch("entity/downloadTicketFile", {
          entityId: this.entityId,
          id: id,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file);
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },
    getDate(date) {
      if (date) {
        return moment(date).format(this.formattedDate);
      }
      return null;
    },
    async removeTicket(id) {
      this.cancelTicketPopup = true;
      this.id = id;
      this.cancelObj = {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      };
      try {
        this.cancelStatus = await this.$store.dispatch(
          "entity/getCancelTicketTemplate"
        );

        //await deleteTickets(id);
        this.getTickets();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async cancelTicket() {
      try {
        await this.$store.dispatch("entity/cancelTicketAction", {
          id: this.id,
          data: this.cancelObj,
        });
        this.cancelTicketPopup = false;
        this.getTickets();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Cancel Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  computed: {
    tickets() {
      return this.$store.getters["entity/getEntityTickets"];
    },
    ...mapState({
      ticketCreated: (state) => state.entity.createTicketResponse,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      ticketData: (state) => state.entity.editTicketTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),

    ticketTemplates() {
      return this.$store.getters["entity/getTicketTemplate"];
    },
  },
  watch: {},
  mounted() {
    this.getTickets();
    this.ticketTemplates();
  },
};
</script>
<style>
.cancel-ticket {
  max-width: 450px;
}
.textbox textarea {
  min-height: 150px;
}
.priority-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.priority-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.priority-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.priority-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
</style>
